module.exports = __webpack_public_path__ + "static/media/slider1.6f741a0d.jpg";